import React, { useState } from 'react';
import styles from './SitePreviewAction.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayoutActions } from '@wix/gg-components/orchestrator';
import { useMsId } from '../../stores/appStore';
import { useSessionId } from '../../hooks';
import { redirectToPremium } from '../../utils/premium';

interface SitePreviewStepActionProps {
  text?: string;
  priority?: 'primary' | 'secondary';
}

export function SitePreviewAction({ text, priority }: SitePreviewStepActionProps) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const msId = useMsId();
  const sessionId = useSessionId();

  const handleRedirectToPremium = async () => {
    if (!msId) {
      return;
    }

    try {
      setIsLoading(true);
      await redirectToPremium({ metaSiteId: msId, sessionId });
    } catch (error) {
      console.error('Error redirecting to premium:', error);
      setIsLoading(false);
    }
  };

  return (
    <StepLayoutActions
      className={styles.root}
      nextCta={{
        text: text || t('site_preview.cta_mobile'),
        disabled: isLoading || !msId,
        skin: 'premium',
        priority,
      }}
      onNext={handleRedirectToPremium}
    />
  );
}
